module.exports = __webpack_public_path__ + "static/media/drilldownGuide.c2b24bb4.svg";